<script setup>
    import { PlusIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <PlusIcon />
</template>
